// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2086":"4aabfa79","3859":"4df7dcd1"}[chunkId] + ".chunk.css";
};